export const RESPONSE_ACTION_CARD_TONES = ['pale', 'neutral', 'green'] as const;

type ResponseActionCardIcon = {
  src: string;
  width: number;
  height: number;
};

export const RESPONSE_ACTION_CARD_ICONS: Readonly<
  Record<string, ResponseActionCardIcon>
> = {
  'protect-and-manage-key-sites': {
    src: '/svg/response-actions/protect-key-sites.svg',
    width: 93,
    height: 113,
  },
  'retain-and-restore-habitats': {
    src: '/svg/response-actions/retain-restore-habitats.svg',
    width: 124,
    height: 124,
  },
  'control-invasive-alien-species': {
    src: '/svg/response-actions/alien-species.svg',
    width: 117,
    height: 98,
  },
  'integrate-climate-adaptation-and-conservation': {
    src: '/svg/response-actions/climate-adaptation.svg',
    width: 108,
    height: 85,
  },
  'promote-sustainable-agriculture-and-forestry': {
    src: '/svg/response-actions/sustainable-agriculture-forestry.svg',
    width: 112,
    height: 86,
  },
  'prevent-overexploitation-and-illegal-killing': {
    src: '/svg/response-actions/illegal-killing.svg',
    width: 100,
    height: 100,
  },
  'implement-nature-safe-land-use-planning': {
    src: '/svg/response-actions/nature-safe-land-use.svg',
    width: 76,
    height: 99,
  },
  'prevent-seabird-bycatch': {
    src: '/svg/response-actions/seabird-bycatch.svg',
    width: 79,
    height: 117,
  },
  'target-species-recovery-actions': {
    src: '/svg/response-actions/target-species-recovery.svg',
    width: 121,
    height: 120,
  },
};
